import React, { } from 'react'
import Header from "../../Header";
import "../../styles/theme.scss"
import { useTranslation } from 'react-i18next';
import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";
import PayementForm from "./PaymentForm";
const Content = styled("div")(({ theme }) => ({
  flexGrow: 1,
  paddingRight: theme.jrnlDrawer.close.width - theme.spacing(1),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // Add margin top here
  // marginTop: theme.spacing(10), // Adjust the spacing as needed
}));
function PaymentContent() {
  const navigate = (path) => {
    // Your custom navigation logic here
    console.log("Navigating to:", path);
    // For example, you might use window.location.href to change the URL
    window.location.href = path;
  };
  const handleNavigation = (path) => {
    navigate(path);
  };
  const { t } = useTranslation();
  return (
    <Grid container>
      <Header
        navigate={handleNavigation}
        children={
          <Content>
            <PayementForm />
          </Content>
        }
      />
    </Grid>
  );
}

export default PaymentContent;
